export type HexColor = `#${string}`;
export type RGBColor = `${number},${number},${number}`;
export type Color = HexColor | RGBColor;

/** Placeholder tint for a photo whose EXIF carries no dominant color yet. */
export const FALLBACK_DOMINANT_COLOR: HexColor = '#cccccc';

/**
 * EXIF colour off the wire is a plain string, and the file row stores `''` when the analyzer had
 * nothing to say — so a nullish check alone would let an empty string reach the model as a colour.
 */
export function toDominantColor(value: string | null | undefined, fallback: HexColor = FALLBACK_DOMINANT_COLOR): HexColor {
  return value?.startsWith('#') ? (value as HexColor) : fallback;
}

/** Ink of a freshly added text block — document content, not a UI surface, so no theme token applies. */
export const DEFAULT_TEXT_COLOR: HexColor = '#000000';
